import React from 'react';
import PropTypes from 'prop-types';

import Accordion from 'relements/build/esm/ui/accordion';
import Icon from 'relements/build/esm/ui/icon';
import Text from 'relements/build/esm/ui/text';
import Button from 'relements/build/esm/ui/button';

import GeneralNodeItem from '../GeneralNodeItem';

import './GeneralNodesBody.scss';
import '@src/containers/FAQNodes/GeneralNodes.scss';

import AddIcon from '@src/containers/FAQNodes/icons/AddIcon.svg';

const GeneralNodesBody = (props) => {
  const {
    orderedNodes,
    scrollExists,
    onAddNewNode,
    activeIndex,
    toggleActive,
    handleToggle,
    dataUpdateCallback,
    updateCurrentSourceLanguage,
  } = props;

  // renders general node
  const renderGeneralNode = () => (node, i) => {
    const isActive = activeIndex === i;
    const activeClassName = isActive ? 'active' : '';
    const inactiveClassName = !isActive && !node.active ? 'inactive' : '';
    return (
      <Accordion.Item
        className={`general-nodes-item ${activeClassName} ${inactiveClassName}`}
        itemIndex={i}
        active={isActive}
        renderHeader={renderGeneralNodeHeader(node)}
        onChange={handleToggle}
      >
        <GeneralNodeItem
          key={`general-node-${node.node_id}`}
          {...node}
          domain={props.meta.domain}
          story={props.meta.story}
          synonyms={props.synonyms}
          meanings={props.meanings}
          updatedSynonyms={props.updatedSynonyms}
          dataUpdateCallback={dataUpdateCallback}
          id={`general-node-${node.node_id}`}
          supportedLanguages={props.supportedLanguages}
          updateCurrentSourceLanguage={updateCurrentSourceLanguage}
          currentLanguage={props.currentLanguage.languageSource}
        />
      </Accordion.Item>
    );
  };

  // renders headers of general node
  const renderGeneralNodeHeader = (node) => ({ ExpandIcon }) => {
    return (
      <div className="general-nodes-item-header">
        {node.title && node.system_name ? (
          <div className="general-nodes-item-header-title">{node.title}</div>
        ) : (
          <div className="general-nodes-item-header-title zero-state">
            Enter Step Name
          </div>
        )}
        <Button onClick={toggleActive(node)}>
          {node.active ? 'Deactivate' : 'Activate'}
        </Button>
        <ExpandIcon />
      </div>
    );
  };

  return (
    <div className="general-nodes-body-cards">
      <Accordion className="general-nodes-body-card">
        {orderedNodes.map(renderGeneralNode())}
      </Accordion>
      <div
        className={`general-nodes-body-add ${
          scrollExists ? 'general-nodes-body-add-box' : ''
        }`}
      >
        <Icon src={AddIcon} onClick={onAddNewNode} />
        <Text variant="h3.semi-bold" color="blue.haptik" onClick={onAddNewNode}>
          {' '}
          Add another FAQ
        </Text>
      </div>
    </div>
  );
};

GeneralNodesBody.propTypes = {
  orderedNodes: PropTypes.arrayOf(PropTypes.object),
  scrollExists: PropTypes.bool,
  onAddNewNode: PropTypes.func,
  activeIndex: PropTypes.number,
  toggleActive: PropTypes.func,
  handleToggle: PropTypes.func,
  dataUpdateCallback: PropTypes.func,
  updateCurrentSourceLanguage: PropTypes.func,
};

export default GeneralNodesBody;
